<template>
  <div class="fl-sym-mt-10">
    <div class="fl-sym-px-4 fl-sym-mt-1">
      <div class="fl-sym-text-primary fl-sym-text-xxs regular">
        UPDATE PROFILE
      </div>
      <div
        class="fl-sym-text-black fl-sym-text-5xl fl-sym-leading-tight fl-sym-font-semibold fl-sym-mb-2 heading"
      ></div>
      <div class="fl-sym-text-intermediat fl-sym-text-lg update-text"></div>
      <form class="fl-sym-mt-2 xnpms:fl-sym-mt-16" method="post">
        <input
          placeholder="Username"
          v-model="username"
          name="username"
          class="fl-sym-w-full fl-sym-p-3 fl-sym-text-lg fl-sym-rounded fl-sym-border fl-sym-border-graduate fl-sym-mb-3 focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
        />
        <span class="error" v-if="errors.username">{{
          errors.username[0]
        }}</span>
        <input
          placeholder="First Name"
          name="first_name"
          v-model="first_name"
          class="fl-sym-w-full fl-sym-p-3 fl-sym-text-lg fl-sym-rounded fl-sym-border fl-sym-border-graduate fl-sym-mb-1 focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
        />
        <span class="error" v-if="errors.first_name">{{
          errors.first_name[0]
        }}</span>

        <input
          placeholder="Last Name"
          name="last_name"
          type="text"
          v-model="last_name"
          class="fl-sym-w-full field__input fl-sym-mt-2 fl-sym-p-3 fl-sym-text-lg fl-sym-rounded fl-sym-border fl-sym-border-graduate fl-sym-mb-1 focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
        />

        <span class="error" v-if="errors.last_name">{{
          errors.last_name[0]
        }}</span>

        <input
          placeholder="Your Email"
          type="text"
          name="email"
          v-model="email"
          class="fl-sym-w-full field__input fl-sym-mt-2 fl-sym-p-3 fl-sym-text-lg fl-sym-rounded fl-sym-border fl-sym-border-graduate fl-sym-mb-1 focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
        />

        <span class="error" v-if="errors.email">{{ errors.email[0] }}</span>

        <div class="loginBtnMargin xs:fl-sym-mt-40 fl-sym-mb-2">
          <button
            type="button"
            class="login-btn fl-sym-text-white fl-sym-bg-primary fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm email-password email-password-text"
          >
            Update Profile
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      errors: [],
      username: null,
      email: null,
      first_name: null,
      last_name: null,
    }
  },
}
</script>
<style>
.error {
  top: 460px;
  left: 20px;
  width: 366px;
  height: 16px;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  font: "SFProDisplay-Regular";
  font-size: 16px;
  color: #ff3a19;
}

.border-red {
  border-color: #ff3a19;
}

.loginBtnMargin {
  margin-top: 20px;
}
.login-btn {
  background: transparent
    linear-gradient(262deg, #19e0ff 0%, var(--progress-bar-filler) 100%) 0% 0%
    no-repeat padding-box;
  background: transparent linear-gradient(262deg, #19e0ff 0%, #00c5e3 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
}

.email-password {
  background-color: white;
  color: black;
}
.margin-top {
  margin-top: -40px;
}

.back {
  font-family: "SFProDisplay-Semibold";
}

.field {
  position: relative;
  display: inline-block;
}
/* .field__input {
  padding-right: 330px;
} */
.field__helper {
  position: absolute;
  right: 5px;
  top: 20px;
  letter-spacing: var(--unnamed-character-spacing-1-4);
  color: var(--progress-bar-filler);
  text-align: center;
  letter-spacing: 1.4px;
  color: #00c5e3;
  opacity: 1;
  cursor: pointer;
}

.already-account {
  color: var(--unnamed-color-6f7878);
  text-align: center;
  letter-spacing: 0.64px;
  color: #6f7878;
  background-color: #d0dada;
  opacity: 0.6;
}
.email-password-text {
  color: var(--progress-bar-filler);
  text-align: center;
  letter-spacing: 0.64px;
  color: white;
  opacity: 1;
}

.heading {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    var(--unnamed-font-size-28) / var(--unnamed-line-spacing-32)
    var(--unnamed-font-family-sf-pro-display);
  letter-spacing: var(--unnamed-character-spacing--0-16);
  color: var(--unnamed-color-000000);
  text-align: left;
  font: normal normal bold 28px/32px SF Pro Display;
  letter-spacing: -0.16px;
  color: #000000;
  font-weight: bold;
  opacity: 1;
}

.update-text {
  letter-spacing: var(--unnamed-character-spacing-0-56);
  color: var(--unnamed-color-6f7878);
  text-align: left;
  letter-spacing: 0.56px;
  color: #6f7878;
  opacity: 1;
}
</style>
